<template>
    <div class="page-container">
        <div class="page-content">
            <div class="content-wrapper">
                <div class="col-md-10 col-md-offset-1">
                    <div class="timeline timeline-left">
                        <div class="timeline-container">
                            <new-item-block @itemAdded="addItem"></new-item-block>
                            <note-item :timeline=true v-for="it in filterItems" :item="it" @itemRemoved="removeItem" :key="it['.key']"></note-item>
                        </div>
                    </div>
                </div>
                <pagination :pagesCount="pagesCount" :current="current" :onPageChange="onPageChange"></pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'
    import Item from './Item.vue'
    import NewItemBlock from './NewItem.vue'
    import Pagination from './Pagination.vue'
    import db from '../db.js'
    import swal from 'sweetalert2'

    let itemsRef = {
      public: db.ref('items/public'),
      private: null,
      extra: null
    };

    export default {
        computed: {
            ...mapState(['mode', 'loggedIn']),
            ...mapGetters(['getUser']),
            filterItems() {
                let from = (this.current - 1) * this.itemsOnPage;
                let till = this.itemsOnPage + from;
                if (this.items.length - till <= 0) till = this.items.length;
                return this.items.slice().reverse().slice(from, till);
            }
        },
        firebase: {
            items: {
              source: itemsRef['public'],
              cancelCallback (err) {
                swal(
                  'Ups!..',
                  "You don't have permissions",
                  'info')
              }
            },
        },
        watch: {
            'mode': function (mode) {
                this.$bindAsArray('items', itemsRef[mode])
            },
            'loggedIn': function (loggedIn) {
                if (loggedIn) {
                    itemsRef.private = db.ref('items/private/' + this.getUser.uid);
                    itemsRef.extra = db.ref('items/extra/' + this.getUser.uid);
                }

            }
        },
        data () {
            return {
                pagesCount: 1,
                current: 1,
                itemsOnPage: 5
            }
        },
        components: {
            noteItem: Item,
            newItemBlock: NewItemBlock,
            Pagination: Pagination
        },
        name: 'app',
        updated () {
            window.instgrm.Embeds.process();
            this.pagesCount = Math.ceil(this.items.length/this.itemsOnPage);
        },
        methods: {
            addItem (item) {
                itemsRef[this.mode].push(item);
            },
            removeItem (item) {
                if (item.owner === this.getUser.uid) {
                    itemsRef[this.mode].child(item['.key']).remove();

                    swal(
                        'OK!',
                        'Puzzle removed',
                        'success')
                } else {
                    swal(
                        'Ups!..',
                        "You don't own this puzzle",
                        'info')
                }
            },
            onPageChange (newCurrent) {
                if (newCurrent > this.pagesCount) newCurrent = this.pagesCount;
                else if (newCurrent < 1) newCurrent = 1;
                this.current = newCurrent;
            }
        }

    }
</script>

<style scoped>
    .has-padding-top {
        padding-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// Main.vue?2f1f705c